import { render, staticRenderFns } from "./reportIssuesModal.vue?vue&type=template&id=c9a4b236&scoped=true&"
import script from "./reportIssuesModal.vue?vue&type=script&lang=js&"
export * from "./reportIssuesModal.vue?vue&type=script&lang=js&"
import style0 from "./reportIssuesModal.vue?vue&type=style&index=0&id=c9a4b236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a4b236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a4b236')) {
      api.createRecord('c9a4b236', component.options)
    } else {
      api.reload('c9a4b236', component.options)
    }
    module.hot.accept("./reportIssuesModal.vue?vue&type=template&id=c9a4b236&scoped=true&", function () {
      api.rerender('c9a4b236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/reportIssuesModal.vue"
export default component.exports